import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import React, { useState, useEffect } from 'react'
import { ModalWrapper } from "./ModalWrapper";

import { useSelector } from "react-redux";
import { useNavigation } from "@react-navigation/native";
import { useRoute } from '@react-navigation/native';
import { switchScreen } from '../../../../hooks/navigate';
import useIsMounted from '../../../../hooks/mounted';

import i18n from "i18n-js";

export const ChannelConfirm = (modal) => {

  const mounted = useIsMounted()
  const navigation = useNavigation();
  const route = useRoute();

  const isWaiting = modal.option?.request?.isWaiting ?? false;
  const isAcknowledged = modal.option?.request?.isAcknowledged ?? false;
  const hasIssues = modal.option?.request?.issues ?? {};

  const channel = useSelector((state) => state.contacts.channels) //
    .filter(_ => _.id === modal.option?.channel?.id)[0] ?? {};

  const [inputd_channel_name, onInputdChannelName] = useState();
  const [do_submit_on_mounted, setSubmitOnUnMounted] = useState(false);

  if (isAcknowledged) {
    modal.onClose();
  }

  useEffect(() => {
    if (channel?.id) {
      // ? restore values for update
      onInputdChannelName(channel?.name ?? '');
      setSubmitOnUnMounted(false);
    }
  }, [channel]);

  const onBack = () => {
    modal.onClose();
  }

  const onSubmit = () => {
    if (!route.params || !('k' in route.params)) {
      submitInputs({ channel });
      return;
    }

    setSubmitOnUnMounted(true);
    switchScreen(navigation, 'channels');
  }

  useEffect(() => {
    return () => {
      if (!mounted() && do_submit_on_mounted) {
        submitInputs({ channel });
      }
    };
  }, [mounted])

  const submitInputs = ({ channel }) => {
    const request = { isWaiting: false, isAcknowledged: false, issues: null };

    // ? request
    request.isWaiting = true;
    request.isAcknowledged = true;

    modal.onUpdate({ request });
    modal.onRequest('DELETE_CHANNEL_INLINE', '/contact/channel/' + channel.id, (
      (null) //
    ), 'DELETE').then((data) => {
      // ---
      console.debug('[Modal]', 'onRequest.then', !!data.result, data?.result)
      // ---
    })
  }

  // const [image, setImage] = useState(channel?.channelImage?.id)

  return (
    <ModalWrapper
      onClose={modal.onClose}
      onBack={onBack}
      onSubmit={onSubmit}

      isVisible={modal.isVisible}
      isWaiting={isWaiting}

      title={i18n.t('channel.deleteChannel')}
      buttonBack={{ text: i18n.t('addContact.cancel') }}
      buttonSubmit={{ text: i18n.t('channel.delete'), action: 'negative' }}
    >
      <Text className="text-md text-secondary-600">{i18n.t('channel.deleteChannelText', { user: inputd_channel_name })}</Text>
      <VStack>
        {'request-failed' in hasIssues && (
          <Text className="mt-2 text-xs text-error-600">{hasIssues['request-failed']}</Text>
        )}
      </VStack>
    </ModalWrapper>
  );
}
